import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarListItemDialogContainer from './VeltCommentsSidebarListItemDialogContainer/VeltCommentsSidebarListItemDialogContainer';
import VeltCommentsSidebarListItemGroup from './VeltCommentsSidebarListItemGroup/VeltCommentsSidebarListItemGroup';
var VeltCommentsSidebarListItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarListItem.DialogContainer = VeltCommentsSidebarListItemDialogContainer;
VeltCommentsSidebarListItem.Group = VeltCommentsSidebarListItemGroup;
export default VeltCommentsSidebarListItem;
